module.exports = __webpack_public_path__ + "media/images/illustrations/unit_sizes/10x10_small-45932bdab9bb3c4f0a52381c5fcaa79b.png";